import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private toasts: any[] = [];

  readonly toastsChanged: Subject<any[]> = new Subject<any[]>();

  /**
   *
   * @returns any[]
   */
  getToasts(): any[] {

    return this.toasts;
  }


  /**
   *
   * @param toast
   */
  remove(toast: any): void {

    if (toast && toast._hideTimeoutId) {
      clearTimeout(toast._hideTimeoutId);
      toast._hideTimeoutId = null;
    }

    this.toasts = this.toasts.filter(t => t !== toast);
    this.toastsChanged.next(this.toasts);
  }


  /**
   *
   * @param type string
   * @param message string
   */
  show(type: 'danger' | 'success' | 'warning' | 'notify', message: string): void {

    let textOrTpl: string | TemplateRef<any>;
    let options: any = {};

    switch(type){

      case 'danger':
        textOrTpl = message;
        options = { classname: 'toast-danger', delay: 5000, title: 'Ошибка' };
        break;
      case 'success':
        textOrTpl = message;
        options = { classname: 'toast-success', delay: 5000, title: 'Уведомление'};
        break;
      case 'warning':
        textOrTpl = message;
        options = { classname: 'toast-warning', delay: 5000, title: 'Предупреждение' };
        break;
      case 'notify':
        textOrTpl = message;
        options = { classname: 'toast-notify', delay: 5000, title: 'Уведомление'};
        break;
      default:
        textOrTpl = message;
        options = { classname: 'toast-notify', delay: 5000 };
        break;
    }

    this.toasts = [...this.toasts, { textOrTpl, ...options }];
    this.toastsChanged.next(this.toasts);
  }
}
